// StatCard — DRY: one small stat tile, reused across tutor/admin dashboards.
interface StatCardProps {
  label: string;
  value: string | number;
}

export default function StatCard({ label, value }: StatCardProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <p className="text-sm text-dm-slate">{label}</p>
      <p className="text-2xl font-semibold text-dm-navy">{value}</p>
    </div>
  );
}
